<template>
  <div class="drawing-tool">
    <canvas
      ref="canvas"
      :width="width"
      :height="height"
      :style="{ width: width + 'px', height: height + 'px' }"
      class="drawing-area"
      @mousedown="downEvent"
      @mouseleave="leaveEvent"
      @mouseup="upEvent"
      @mousemove="moveEvent"
      @touchstart.prevent="downEvent"
      @touchcancel.prevent="leaveEvent"
      @touchend.prevent="upEvent"
      @touchmove.prevent="moveEvent"
    />

    <div class="navigation-bar">
      <div class="navigation-bar__item">
        <v-btn
          color="red"
          icon
          @click="removeHistoryStroke"
        >
          <v-icon>mdi-undo</v-icon>
        </v-btn>
      </div>

      <div class="navigation-bar__item">
        <v-btn
          x-large
          color="red"
          icon
          @click="$emit('click-camera')"
        >
          <v-icon x-large>
            mdi-camera
          </v-icon>
        </v-btn>
      </div>
      <!--
      <div class="navigation-bar__item">
        <input type="file" capture="camera" name="" id="" />
      </div> -->

      <div
        v-if="backgroundLayer"
        class="navigation-bar__item"
      >
        <v-btn
          color="red"
          icon
          @click="$emit('delete-background')"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </div>

      <div class="navigation-bar__item">
        <v-btn
          color="red"
          icon
          @click="$emit('save', c.toDataURL('image/png'))"
        >
          <v-icon>mdi-content-save</v-icon>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppDrawingTool",

  props: {
    width: {
      type: Number,
      default: 200,
    },

    height: {
      type: Number,
      default: 200,
    },

    backgroundLayer: {
      type: String,
      default: "",
    },

    drawing: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      c: null,
      ctx: null,

      mouseDown: false,
      mouseX: 0,
      mouseY: 0,

      tempHistory: [],

      stroke_counter: 0,

      fab: false,

      // Flag to show Camera component
      showCamera: false,

      showCameraStream: false,

      // List of points
      history: [],

      // Available colors
      colors: ["#13f7ab", "#138cf7", "#f71313"],

      // Selected color
      color: "#138cf7",

      // Flag for colors btn fab
      fabColor: false,

      // Available brushsize
      sizes: [6, 12, 24, 48],

      // Selected brushsize
      size: 6,

      // Flag for brushsizes btn fab
      fabSize: false,

      // How many touch event to skip
      modulo: 2,

      // Captured image
      capturedImage: null,

      imageBlob: null,
    };
  },

  watch: {
    backgroundLayer: {
      handler() {
        this.redraw();
      },
      deep: true,
    },

    drawing: {
      deep: true,
      handler() {
        this.decodeBase64();
      },
      immediate: true,
    },
  },

  async mounted() {
    this.decodeBase64();

    await this.init();

    this.redraw();

    // this.$emit("final-image", this.c.toDataURL("image/png"));
  },

  methods: {
    // Load an image a return a pomise
    loadImage(imageSource) {
      return new Promise((resolve, reject) => {
        let image = new Image();
        image.crossOrigin = "";
        image.onload = () => resolve(image);
        image.onerror = reject;
        image.src = imageSource;
      });
    },

    // Encode history to Base64
    encodeToBase64() {
      const history = JSON.stringify(this.history);
      const historyBase64 = btoa(history);

      // Emptu in base64
      if (historyBase64 === "W10=") {
        return "";
      }

      return historyBase64;
    },

    // Decode history from Base64 to json
    decodeBase64() {
      if (!this.drawing || this.drawing == "null") {
        return;
      }

      const historyBase64 = this.drawing;
      const history = atob(historyBase64);

      this.history = JSON.parse(history);
    },

    // Remove a stroke
    removeHistoryStroke() {
      this.history = this.history.filter((x) => x.s < this.stroke_counter);
      this.redraw();

      this.$parent.$emit("update:drawing", this.encodeToBase64(this.history));

      // Emit final image
      // this.$parent.$emit("final-image", this.c.toDataURL("image/png"));
    },

    // Remove all points
    removeAllHistory() {
      this.history = [];
      this.stroke_counter = 0;
      this.redraw();
      // this.$emit("input", this.encodeToBase64());
      this.$emit("update:drawing", this.encodeToBase64(this.history));
    },

    // Start tracking
    downEvent(e) {
      this.stroke_counter++;
      this.mouseDown = true;

      // If is mouse event
      this.mouseX = e.offsetX;
      this.mouseY = e.offsetY;

      // Check if is touch event
      if (e.touches) {
        this.mouseX =
          e.touches[0].pageX - this.$refs.canvas.getBoundingClientRect().left;
        this.mouseY =
          e.touches[0].pageY - this.$refs.canvas.getBoundingClientRect().top;
      }

      this.setDummyPoint();
    },

    // Remove tracking for mouseup/touchend events
    upEvent() {
      if (this.mouseDown) {
        this.setDummyPoint();
      }
      this.mouseDown = false;
      this.$parent.$emit("update:drawing", this.encodeToBase64(this.history));
    },

    // Leaving zone: remove tracking
    leaveEvent() {
      if (this.mouseDown) {
        this.setDummyPoint();
      }
      this.mouseDown = false;
    },

    // If mouse is down add points to history
    moveEvent(e) {
      if (this.mouseDown) {
        // If is mouse event
        this.mouseX = e.offsetX;
        this.mouseY = e.offsetY;

        // Check if is touch event
        if (e.touches) {
          this.mouseX =
            e.touches[0].pageX - this.$refs.canvas.getBoundingClientRect().left;
          this.mouseY =
            e.touches[0].pageY - this.$refs.canvas.getBoundingClientRect().top;
        }

        if (this.current_modulo < this.modulo) {
          this.current_modulo++;
          return;
        }

        var item = {
          isDummy: false,
          x: this.mouseX,
          y: this.mouseY,
          c: this.color,
          r: this.size,
          s: this.stroke_counter,
        };

        this.history.push(item);
        this.draw(item, this.history.length);
      }
    },

    // Get a false point to start and finish lines
    getDummyItem() {
      var lastPoint = this.history[this.history.length - 1];

      if (lastPoint == undefined) {
        lastPoint = { x: this.mouseX, y: this.mouseY };
      }

      return {
        isDummy: true,
        x: lastPoint.x,
        y: lastPoint.y,
        c: null,
        r: null,
        s: this.stroke_counter,
      };
    },

    // Get a false point to start and finish lines
    setDummyPoint() {
      var item = this.getDummyItem();
      this.history.push(item);
      this.draw(item, this.history.length);
      this.current_modulo = 0;
    },

    // Clear canvas and redraw all points and images
    async redraw() {
      if (!this.c) {
        return;
      }

      // Reset canvas
      this.ctx.clearRect(0, 0, this.c.width, this.c.height);

      var bgImg;
      var capturedImg;

      // Check if there is a background image
      if (this.backgroundLayer != "" && this.backgroundLayer) {
        // Draw the image on canvas
        try {
          bgImg = await this.loadImage(this.backgroundLayer);

          const scale = Math.min(
            this.c.width / bgImg.width,
            this.c.height / bgImg.height
          );

          this.ctx.drawImage(
            bgImg,
            this.c.width / 2 - (bgImg.width / 2) * scale,
            this.c.height / 2 - (bgImg.height / 2) * scale,
            bgImg.width * scale,
            bgImg.height * scale
          );
        } catch (e) {
          console.error("Background image not loaded");
        }
      }

      // Check if there is a captured image
      if (this.capturedImage != null && this.backgroundImage == "") {
        capturedImg = await this.loadImage(this.capturedImage);
        this.ctx.drawImage(capturedImg, 0, 0, this.c.width, this.c.height);
      }

      // If there are no points to draw, we are done
      if (!this.history.length) return;

      // Draw each point on canvas
      this.history.forEach((item, i) => {
        this.draw(item, i);
      });

      // classify on same stroke
      this.stroke_counter = 0;
      var last = this.history[this.history.length - 1];
      if (last != undefined) {
        this.stroke_counter = last.s;
      }

      // Emit final image
      this.$emit("final-image", this.c.toDataURL("image/png"));
    },

    // Draw a point on canvas based on item
    draw(item, i) {
      this.ctx.lineCap = "round";
      this.ctx.lineJoin = "round";

      // Previous item
      const prevItem = this.history[i - 2];

      // Dont go below index 2
      if (i < 2) {
        return;
      }

      // Start drawing
      if (!item.isDummy && !this.history[i - 1].isDummy && !prevItem.isDummy) {
        this.ctx.strokeStyle = item.c;
        this.ctx.lineWidth = item.r;

        this.ctx.beginPath();
        this.ctx.moveTo(prevItem.x, prevItem.y);
        this.ctx.lineTo(item.x, item.y);
        this.ctx.stroke();
        this.ctx.closePath();
      } else if (!item.isDummy) {
        this.ctx.strokeStyle = item.c;
        this.ctx.lineWidth = item.r;

        this.ctx.beginPath();
        this.ctx.moveTo(item.x, item.y);
        this.ctx.lineTo(item.x, item.y);
        this.ctx.stroke();
        this.ctx.closePath();
      }
    },

    // Initialize canvas
    init() {
      this.c = this.$refs.canvas;
      this.ctx = this.c.getContext("2d");

      this.mouseDown = false;
      this.mouseX = 0;
      this.mouseY = 0;

      this.tempHistory = [];

      this.stroke_counter = 0;

      return Promise.resolve(this.c);
    },
  },
};
</script>

<style lang="scss" scoped>
.drawing-tool {
  height: 100%;

  .navigation-bar {
    box-shadow: 0 10px 13px -6px rgba(0, 0, 0, 0.2),
      0 20px 31px 3px rgba(0, 0, 0, 0.14), 0 8px 38px 7px rgba(0, 0, 0, 0.12) !important;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    position: fixed;
    bottom: 0;
    left: 0;
    padding: 0;
    margin: 0;
    width: 100%;
    background: white;

    &__item {
      padding: 15px;
    }
  }
}
</style>
